import React from 'react';
import { CustomSVG } from '../../CustomSVG/CustomSVG';
import ProjectSvg from '../../../assets/icons/nav/project.svg?raw';

export const ProjectIcon = (props) => <CustomSVG svg={ProjectSvg} preserveColors {...props} />;
